import { useLocalSearchParams } from 'expo-router';

import { BoatTypeScreen } from '@/components/riviera/boat-type-screen';

export { generateBoatTypeStaticParams as generateStaticParams } from '@/lib/detail/boat-rental-detail';

// One boat type in one city, e.g. /fr/boat-rental/cannes/catamaran — the
// landing page for "location catamaran cannes" searches. Only city × type
// pairs with enough boats are exported — see generateBoatTypeStaticParams.
export default function BoatRentalTypeScreen() {
  const { city, type } = useLocalSearchParams<{ city: string; type: string }>();
  return <BoatTypeScreen cityId={city ?? ''} type={type ?? ''} />;
}
